export default "__VITE_ASSET__e662af97__"